export const settings = {
    time: 300,
    flaskServer: "https://symmetryflask.herokuapp.com/",
    KORAPIKey: "4f489fad-85bf-406b-bc17-47138a495508",
    nsKey: 65,
    sKey: 83,
    nsKey_string: "a",
    sKey_string: "s",
    practice_required_acc: 0.75,
    waittime: 1000,
    waitmin: 1000,
    waitmax: 1500,
    breakdelay: 2000,

    baseline1key: 32,
    baseline1key_string: "space bar",
    baselineImageShow: 300,
    baselineImageBetween: 300
}